import { useEffect } from "react";
import { X } from "lucide-react";

// Slide-out drawer panel (right side) for create/edit forms
export default function SlidePanel({ open, onClose, title, subtitle, children, footer }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return (
    <>
      <button
        aria-label="Close panel"
        onClick={onClose}
        className={`fixed inset-0 z-[9998] bg-black/60 transition-opacity duration-300 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      />
      <aside
        data-testid="slide-panel"
        className={`fixed top-0 right-0 z-[9999] h-screen w-full max-w-xl bg-[#151515] border-l border-[#D8D6D0]/10 shadow-2xl transform transition-transform duration-300 flex flex-col ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <header className="flex items-start justify-between gap-4 px-6 py-5 border-b border-[#D8D6D0]/10">
          <div className="min-w-0">
            <h2 className="font-serif-display text-2xl truncate">{title}</h2>
            {subtitle && <p className="text-xs text-[#D8D6D0]/50 mt-1">{subtitle}</p>}
          </div>
          <button
            data-testid="slide-panel-close"
            onClick={onClose}
            className="p-2 hover:bg-[#1f1f1f] transition-colors text-[#D8D6D0]/70 hover:text-[#F5F3EF]"
          >
            <X className="w-5 h-5" />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto px-6 py-6">{children}</div>

        {footer && (
          <footer className="border-t border-[#D8D6D0]/10 px-6 py-4 pr-32 md:pr-40 bg-[#0d0d0d]">{footer}</footer>
        )}
      </aside>
    </>
  );
}
